import { Box, Flex, Stack } from '@chakra-ui/react'
import type { FC } from 'react'
import { useCallback } from 'react'
import type { OperationResult } from 'urql'

import EmptyStatePrompt from './components/emptyStatePrompt'

import ChatDrawerHeader from '@app/pages/strategies/components/aiChat/components/chatDrawerHeader'
import PromptForm from '@app/pages/strategies/components/aiChat/components/promptForm'
import { useChatNavigationContext } from '@app/pages/strategies/components/aiChat/contexts/aiChatNavigationContext'
import PipelineInstructions from '@app/pages/strategies/components/aiChat/pipelineInstructions'
import type { PipelineRunMutation } from '@graphql/queries'
import type { ChattableObjectInput, PipelineEnum } from '@graphql/types'

type Props = {
  pipelineId: PipelineEnum
  chattableId: string | null
  chattableType: keyof ChattableObjectInput
  strategyId?: string
  inDrawer?: boolean
}

const New: FC<Props> = ({ pipelineId, chattableId, chattableType, strategyId = null, inDrawer = true }) => {
  const navContext = useChatNavigationContext()

  const onSuccess = useCallback(
    (result: OperationResult<PipelineRunMutation>) => {
      const chatId = result?.data?.pipelineRun?.chat?.id

      if (chatId) {
        navContext.show(chatId)
      }
    },
    [navContext]
  )

  return (
    <Flex pos="relative" direction="column" overflow="hidden" h="100%" bg="bg">
      <ChatDrawerHeader closable={inDrawer} />
      <Flex overflowY="auto" pt="0" pb="40" grow={1}>
        <Stack gap="10" w="100%" mx="auto" px={4}>
          <EmptyStatePrompt>
            <PipelineInstructions pipelineId={pipelineId} />
          </EmptyStatePrompt>
        </Stack>

        <Box
          pos="absolute"
          bottom="0"
          mx="4"
          py="4"
          bgGradient="to-t"
          gradientFrom="bg.canvas 80%"
          gradientTo="rgba(0,0,0,0)"
          insetX="0"
        >
          <Stack mx="auto">
            <PromptForm
              pipelineId={pipelineId}
              chattableType={chattableType}
              chattableId={chattableId}
              strategyId={strategyId}
              onSuccess={onSuccess}
            />
          </Stack>
        </Box>
      </Flex>
    </Flex>
  )
}

export default New
